<template lang="pug">
  v-layout(row)
    v-flex(xs12 sm6 offset-sm3)
      v-card
        v-toolbar(color="white" flat)
          v-toolbar-title(class="grey--text text--darken-4") Create an event
        v-form
          v-container
            v-text-field(v-model="eventName" label="Event Name") 
            v-text-field(v-model="location" label="Location") 
            v-menu(
              ref="menu1"
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px")
        
              v-text-field(
                slot="activator"
                v-model="dateFormatted"
                label="Date"
                hint="DD/MM/YYYY format"
                readonly
                persistent-hint
                prepend-icon="event")
              v-date-picker(v-model="date" no-title @input="menu1 = false")
            v-menu(
              ref="menu2"
              :close-on-content-click="false"
              v-model="menu2"
              :nudge-right="40"
              :return-value.sync="startTime"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px")

              v-text-field(
                slot="activator"
                v-model="startTime"
                label="Start Time"
                :background-color = "tcolor"
                :hint = "res"
                prepend-icon="access_time"
                readonly)
              v-time-picker(
                v-if="menu2"
                v-model="startTime"
                full-width
                @change="$refs.menu2.save(startTime); validateTime()")
            v-menu(
              ref="menu3"
              :close-on-content-click="false"
              v-model="menu3"
              :nudge-right="40"
              :return-value.sync="endTime"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px")

              v-text-field(
                slot="activator"
                v-model="endTime"
                label="End Time"
                prepend-icon="access_time"
                :background-color = "tcolor"
                :hint = "res"
                readonly)
              v-time-picker(
                v-if="menu3"
                v-model="endTime"
                full-width
                @change="$refs.menu3.save(endTime); validateTime()")
            v-textarea(
              name="description"
              v-model="description"
              label="Description"
              hint="Hint text")
            image-upload
            v-btn(@click="save") Save

</template>
<script>
const ImageUpload  = () => import('../../components/ImageUpload') 
export default {
  name: 'CreateEvent',
  components: {ImageUpload},
  data: () => ({
    description:'' ,
    location:'',
    eventName:'',
    menu1: false,
    menu2: false,
    menu3: false,
    dateFormatted:'',
    startTime: '',
    tcolor: '',
    endTime:'',
    date:'',
    res:''
  }),
  watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      }
    },
  methods:{
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    save(){
      let event = {
        eventName: this.eventName,
        description: this.description,
        eventDate: this.dateFormatted,
        startTime: this.startTime,
        endTime: this.endTime,
        imageURL: this.$store.state.imageURL,
        location: this.location
        
      }
      this.$store.dispatch('saveEvent', event)
    },
    validateTime(){
      if (this.startTime < this.endTime){
        this.res = ""
        this.tcolor = ''
      }else{
        if (this.startTime && this.endTime){
        this.res = "Start time must be earlier than end time"
        this.tcolor = "red accent-1"
        }
      }
    }
  }

}
</script>
